import { render, staticRenderFns } from "./ApiLoader.vue?vue&type=template&id=2b9f2766&"
import script from "./ApiLoader.vue?vue&type=script&lang=ts&"
export * from "./ApiLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports